import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { isOrHandleAsExternalUrl as A } from "../../../helpers/link-helper.js";
import { isArrayWithItems as m } from "../../../helpers/array-helper.js";
import "dayjs";
import { useAnimateFadeIn as u, useAnimateFadeInToTop as y } from "../../../animation/animation.js";
import { Carousel as T } from "../../elements/carousel/carousel.js";
import { Heading as v } from "../../elements/heading/heading.js";
import r from "./card-list-block-v2.module.less.js";
import { m as f } from "motion/react";
import { Card as w } from "../../elements/card/card.js";
import "react";
import "react-i18next";
import "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import { LinkAnchor as j } from "../../elements/link/link.js";
import "@vis.gl/react-google-maps";
import "haversine-distance";
const G = ({
  title: n,
  text: d,
  link: a,
  standardCards: l,
  productCards: c,
  isCarousel: h,
  index: N
}) => {
  const I = u({ whileInView: !0, easing: "easeInOut", displayAmountTreshold: 0.01 }), g = u({
    whileInView: !0,
    easing: "easeInOut"
  }), x = y({ whileInView: !0, delay: 0.2, easing: "easeOut" }), t = l ? l.map((i) => /* @__PURE__ */ e(w.Standard, { ...i })) : [], o = c ? c.map((i) => /* @__PURE__ */ e(w.Product, { ...i })) : [];
  return /* @__PURE__ */ e("section", { className: r.wrapper, children: /* @__PURE__ */ p(
    f.div,
    {
      ...h ? g : I,
      className: [r.innerWrapper, "max-width padded-sides"].join(" "),
      children: [
        (n || a) && /* @__PURE__ */ p("div", { className: r.topWrapper, children: [
          n && /* @__PURE__ */ e(
            v,
            {
              index: N,
              semanticType: "h2",
              visualType: "h3",
              className: [r.title, "heading-max-width"].join(" "),
              children: n
            }
          ),
          a && /* @__PURE__ */ e(f.div, { ...x, className: r.linkWrapper, children: /* @__PURE__ */ e(
            j.Secondary,
            {
              label: a.title,
              url: a.url,
              iconRight: a.icon ?? "ui-icon-arrow-right",
              openInNewTab: A(a.url, a.target),
              onPreNavigate: a.onPreNavigate
            }
          ) })
        ] }),
        d && /* @__PURE__ */ e("p", { className: [r.text, "body-l text-max-width"].join(" "), children: d }),
        h ? /* @__PURE__ */ e(
          T,
          {
            wrapperClassName: r.carouselWrapper,
            items: m(o) ? o : m(t) ? t : []
          }
        ) : /* @__PURE__ */ p("ul", { className: `${r.list}`, children: [
          m(o) && o?.map((i, s) => /* @__PURE__ */ e("li", { className: r.item, children: i }, s)),
          m(t) && t?.map((i, s) => /* @__PURE__ */ e("li", { className: r.item, children: i }, s))
        ] })
      ]
    }
  ) });
};
export {
  G as CardListBlockV2,
  G as default
};
